module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/biglogo.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer_right"
  }, [_c('div', {
    staticClass: "compony"
  }, [_vm._v("北京维学教育科技有限公司")]), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('span', [_vm._v("weici@weixuetec.com")]), _vm._v("\n      Ι\n      "), _c('span', [_vm._v("京ICP备16053030号")]), _vm._v("\n      Ι\n      "), _c('a', {
    staticClass: "wechat",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/wechat.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "show_qrcode"
  })]), _vm._v("\n\n      Ι\n      "), _c('span', [_vm._v("电话：010-82809918-8020")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "15px",
      "margin-top": "6px"
    }
  }, [_vm._v("地址：北京朝阳区北苑路北辰新纪元大厦2号楼 804")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "300px",
      "margin": "0 auto",
      "padding": "20px 0 0 0"
    }
  }, [_c('a', {
    staticStyle: {
      "display": "inline-block",
      "text-decoration": "none",
      "height": "20px",
      "line-height": "20px"
    },
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502033934"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "left",
      "width": "20px"
    },
    attrs: {
      "src": require("../assets/images/beian.png")
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "left",
      "height": "20px",
      "line-height": "20px",
      "margin": "0px 0px 0px 5px",
      "color": "#939393",
      "font-size": "14px"
    }
  }, [_vm._v("\n        京公网安备 11010502033934号\n      ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e5b8f04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 95
// module chunks = 0